export default __webpack_public_path__ + "static/media/bnr6.dd7675b5.jpg";